import type { LoaderFunctionArgs } from '~/types/route-args';
import type { ShouldRevalidateFunction } from 'react-router';
import { data as routerData } from 'react-router';
import { getStatsNumbers } from '~/modules/error/api/get-stats-numbers.server';

export const STATS_NUMBERS_ACTION = '/actions/stats-numbers';

/**
 * API endpoint to get the number of items we have in each directory item category.
 * Use with the `useStatsNumbers` hook.
 * @see {@link packages/web/app/modules/root/hook/use-stats-numbers.ts}
 */
export const loader = async ({ context }: LoaderFunctionArgs) => {
    const { logger } = context;
    try {
        const statsNumbers = await getStatsNumbers(context);

        return {
            statsNumbers,
        };
    } catch (error) {
        logger.error('Error in /actions/stats-numbers', { error });
        return routerData(null, { status: 500 });
    }
};

export const shouldRevalidate: ShouldRevalidateFunction = () => {
    return false;
};
